module.exports = __webpack_public_path__ + "static/media/team.e738f8dc.jpg";